
import { KTCard } from '../../../../_metronic/helpers'
import { Card4 } from '../../../../_metronic/partials/content/cards/Card4'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import React, { useState } from 'react'
import { useAuth } from '../../auth'



type Feature = {
  name: string
  icon: string
  to: string
  badge?: string
  isModal?: boolean
}

const Menu = () => {
  const { isFranchise, isSupplyChainManager, isFacilityManager, currentUser } = useAuth()
  const [showInclusiveAIModal, setShowInclusiveAIModal] = useState(false)



  const checkAIEnabled = () => {
    try {
      const authData = localStorage.getItem('kt-auth-react-v')
      if (authData) {
        const parsed = JSON.parse(authData)
        return parsed?.data?.enabledFeatures?.includes('AI') || false
      }
    } catch (error) {
      console.error('Error parsing auth data:', error)
    }
    return false
  }

  const isAIEnabled = checkAIEnabled()


  const features: Feature[] = [
    ...((currentUser as any)?.userType === "CLIENT"
      ? [{ name: 'Supply chain report', icon: 'FTS Supply chain report', to: 'supply-chain-report' }]
      : [
        ...(((isFranchise || isSupplyChainManager || isFacilityManager) && [
          { name: 'Inventory', icon: 'FTS Inventory', to: 'stock' },
        ]) || []),
        { name: 'Daily report', icon: 'FTS Daily Report', to: 'daily-reports' },
        // { name: 'Weekly', icon: 'monthly (2)', to: 'weekly-reports' },
        { name: 'Monthly', icon: 'FTS Monthly report', to: 'monthly-reports' },
        { name: 'Annual', icon: 'FTS Annual Report', to: 'inventory' },
        ...((((currentUser as any)?.userType !== "PICKUP_POINT_STAFF") && [
          { name: 'Supply chain report', icon: 'FTS Supply Chain Report', to: 'monthly-reports-2' },
        ]) || []),
        ...((!isFacilityManager && [
          // { name: 'User', icon: 'user ', to: 'user-performance' },
        ]) || []),
        ...((isSupplyChainManager && [{ name: 'Traceability', icon: 'FTS Traceability', to: 'wfd' }]) || []),
        // { name: 'Material Report', icon: 'mr', to: 'material-report', badge: 'New' },
        // { name: 'Inclusiv AI', icon: 'inclusiv ai icon', to: 'inclusiv-ai', isModal: !isAIEnabled },
      ]
    ),
  ]

  const handleFeatureClick = (feature, e) => {
    if (feature.name === 'Inclusiv AI' && !isAIEnabled) {
      e.preventDefault()
      setShowInclusiveAIModal(true)
      return
    }

    if (feature.isModal) {
      e.preventDefault()
      setShowInclusiveAIModal(true)
    }
  }

  const closeModal = () => {
    setShowInclusiveAIModal(false)
  }

  return (
    <>
      <KTCard addCard={false}>
        <div className='row g-xl-4'>
          {features.map((eachFeatures, eachIndex) => (
            <div key={eachIndex + 1 + ''} className='col col-lg-2'>
              {eachFeatures.isModal ? (
                // For modal items, use div instead of Link
                <div
                  className={clsx('menu-link without-sub')}
                  onClick={(e) => handleFeatureClick(eachFeatures, e)}
                  style={{ position: 'relative', cursor: 'pointer' }}
                >
                  <Card4
                    icon={`/media/svg/files/${eachFeatures.icon}.png`}
                    title={eachFeatures.name}
                    description=''
                  />
                  {eachFeatures.badge && (
                    <span style={{
                      backgroundColor: '#dc3545',
                      color: 'white',
                      fontSize: '10px',
                      padding: '2px 6px',
                      borderRadius: '4px',
                      fontWeight: '500',
                      position: 'absolute',
                      top: '8px',
                      right: '8px',
                      zIndex: 10
                    }}>
                      {/* {eachFeatures.badge} */}
                    </span>
                  )}
                </div>
              ) : (
                // For regular navigation items, use Link
                <Link
                  className={clsx('menu-link without-sub')}
                  to={eachFeatures.to}
                  style={{ position: 'relative' }}
                  onClick={(e) => handleFeatureClick(eachFeatures, e)}
                >
                  <Card4
                    icon={`/media/svg/files/${eachFeatures.icon}.png`}
                    title={eachFeatures.name}
                    description=''
                  />
                  {eachFeatures.badge && (
                    <span style={{
                      backgroundColor: '#dc3545',
                      color: 'white',
                      fontSize: '10px',
                      padding: '2px 6px',
                      borderRadius: '4px',
                      fontWeight: '500',
                      position: 'absolute',
                      top: '8px',
                      right: '8px',
                      zIndex: 10
                    }}>
                      {eachFeatures.badge}
                    </span>
                  )}
                </Link>
              )}
            </div>
          ))}
        </div>
      </KTCard>

      {/* Inclusive AI Modal */}
      {showInclusiveAIModal && (
        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Inclusive AI</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="text-center py-5">
                  <p className="text-dark mb-4">
                    Your current subscription does not allow access to this feature.
                    Kindly drop an email to info@asmglobal.co.in to get to know more about this feature.
                  </p>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn"
                  style={{ backgroundColor: '#333333', color: 'white' }}
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const ReportsMenu = () => <Menu />
export { ReportsMenu }